
import React, { useState } from 'react';
import ImageDisplay from './ImageDisplay';
import './ImageStudy.css';

const ImageStudy = () => {
  const items = [
    { word: 'Apple', src: '/images/apple.jpg' },
    { word: 'Banana', src: '/images/banana.jpg' },
    { word: 'Cherry', src: '/images/cherry.jpg' },
    {word: 1,src:''},
    // Add more items as needed
  ];

  return (
    <div className="AppIS">
      <h1>Image Words</h1>
      <ImageDisplay items={items} />
    </div>
  );
};

export default ImageStudy;